var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJiimInitial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x84\xB6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M36.7,49.2s-4-.8-4.1-1.5.8-3.6,1.3-3.8,3.6.3,4.1.9-.4,3.3-.6,3.7S37.2,49.3,36.7,49.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7,
    d: "M34,47.37l-1.77.7,6.72-2.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M10.5,39.5V35.3H41.4s-5.9-5.9-8.8-6-5.1-.2-5.1-.2,2.5-4.6,5.9-5,16.1,11,16.1,11h2.6v5.7H10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    strokeWidth: 7,
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    className: "cls-2",
    d: "M26.7,28.5s5.8-3.6,9.3-1.7S49.8,38.5,49.8,38.5H9.7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiimInitial);
export default __webpack_public_path__ + "static/media/jiim-initial.a20892afa02d4c37ae6855fef0d63a56.svg";
export { ForwardRef as ReactComponent };